var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagePrint = function SvgImagePrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M9.4 21.8v4.4h13v-4.4zm.2-19V13h12.8V2.8zM6.8 0H25v10h2.6c2.4 0 4.4 1.8 4.4 4.2v11h-7v3.4H6.8v-3.4H0v-11c0-2.4 2-4.2 4.4-4.4h2.4z"
  })));
};
export { SvgImagePrint as ReactComponent };
export default __webpack_public_path__ + "assets/ImagePrint.c620b45fbe6c49742e46824eb38e0774.svg";